/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentVideo.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { View } from 'foundations-components/components/View';
import { ShortContentCompletedVideoView } from '../components/ShortContentCompletedVideoView.migrated';
import { VideoPlayerWithControls } from '../../video/index.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentVideo.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const ShortContentVideo = ({
  additionalTracking,
  playlistId,
  displayInteractiveEducation,
  handleDisplayInteractiveEducation,
  interactiveEducationEnabled,
  short,
  viewProps
}) => {
  const isInCollection = !!playlistId;
  const {
    name,
    contentId
  } = short || {};
  if (!short) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, Object.assign({}, viewProps, {
    children: /*#__PURE__*/_jsx(VideoPlayerWithControls, {
      additionalTracking: additionalTracking,
      completedVideoView: isInCollection ? undefined : /*#__PURE__*/_jsx(ShortContentCompletedVideoView, {
        isInCollection: false,
        short: short
      }),
      displayInteractiveEducation: displayInteractiveEducation,
      enableAdaptToIndustry: true,
      enableQuizMe: true,
      enableSummarize: true,
      handleDisplayInteractiveEducation: handleDisplayInteractiveEducation,
      interactiveEducationEnabled: interactiveEducationEnabled,
      isPubliclyVisible: true // TODO: Update this to read short visibility when available
      ,
      playlistId: playlistId,
      shortId: contentId,
      shortName: name
    })
  }));
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentVideo.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default ShortContentVideo;